export const SETTINGS_EXTRA_AMOUNT_VALIDATION = Object.freeze({
  REQUIRED: "required",
  NON_ZERO: "non_zero",
});

export const getSettingsExtraAmountValidation = (value) => {
  const text = String(value ?? "").trim();
  if (!text) return SETTINGS_EXTRA_AMOUNT_VALIDATION.REQUIRED;

  const amount = Number(text);
  if (!Number.isFinite(amount)) {
    return SETTINGS_EXTRA_AMOUNT_VALIDATION.REQUIRED;
  }
  if (Math.round(amount * 100) === 0) {
    return SETTINGS_EXTRA_AMOUNT_VALIDATION.NON_ZERO;
  }
  return null;
};

export const isValidSettingsExtraAmount = (value) =>
  getSettingsExtraAmountValidation(value) === null;
